module.exports = __webpack_public_path__ + "img/iconfont.1bc587b5.svg";